<template>
  <v-row class="version-info">
    <v-col>
      <span>
        Client Build: {{ buildNumber }}</span><br />
      <span v-if="serverInfo" class="server-version">
        Server Version: {{ serverInfo.version }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
import gql from "graphql-tag";

export default {
  computed: {
    buildNumber() {
      return process.env.VUE_APP_BUILD_NUMBER;
    },
  },
  apollo: {
    serverInfo: {
      query: gql`
        query {
          serverInfo {
            version
            id
          }
        }
      `,
      update(data) {
        return data.serverInfo;
      },
    },
  },
};
</script>

<style scoped>
.version-info {
  opacity: 0.6;
  font-size: 0.8em;
}

.server-version {
  margin-top: 0.5rem;
}
</style>
